import "./index.scss";
import { Card, Form, Input, Button, message } from "antd";
import logo from "../../assets/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchLogin } from "../../store/modules/userStore";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { fetchArea } from "../../store/modules/areaStore";


const Login = () => {
  const dispatch = useDispatch();
  // const refreshToken = useRefreshToken();
  const navigate = useNavigate();
  const islogined = useSelector((state) => state.user.islogined);
  const onFinish = (values) => {
    console.log("提交登录信息", values);
    dispatch(fetchLogin(values));
  };
  useEffect(() => {
    // 获取到token之后，跳转到首页
    if (islogined) {
      console.log("已经拿到token，即将跳转");
      dispatch(fetchArea())
      navigate("/");
    }
  }, [islogined, navigate,dispatch]);

  return (
    <div className="login">
      <Card className="login-container">
        <img className="login-logo" src={logo} alt="logo" />
        {/* 登录表单 */}
        <Form onFinish={onFinish} validateTrigger="onBlur">
          {/* {表单校验} */}
          <Form.Item
            label="账号"
            name="username"
            rules={[
              // 支持多条校验逻辑
              {
                required: true,
                message: "请输入账号",
              },
            ]}
          >
            <Input size="large" placeholder="请输入账号" />
          </Form.Item>
          <Form.Item
            label="密码"
            name="password"
            rules={[{ required: true, message: "请输入密码" }]}
          >
            <Input.Password size="large" placeholder="请输入密码" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" size="large" block>
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
